import React, { useEffect, useRef, useState } from "react";
import { applyServerData, getSyncPayload } from "../lib/store";
import { RadioTower } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      if (!sessionId) {
        window.location.replace("/");
        return;
      }
      try {
        const res = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("session failed");

        // Synchroniser la progression
        const pr = await fetch(`${API}/api/progress`, { credentials: "include" });
        if (pr.ok) {
          const data = await pr.json();
          if (data && data.progress) {
            applyServerData(data); // le serveur a des données → on les récupère
          } else {
            // Premier login : on pousse la progression locale existante
            await fetch(`${API}/api/progress`, {
              method: "PUT",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(getSyncPayload()),
            });
          }
        }
        // Rechargement propre : l'app relit le cookie + la progression fraîche
        window.location.replace("/");
      } catch {
        setError(true);
      }
    };
    run();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen grid place-items-center bg-background text-foreground grain">
      <div className="text-center">
        <div className="inline-grid place-items-center w-14 h-14 rounded-sm bg-primary text-primary-foreground animate-pulse mb-4">
          <RadioTower size={26} />
        </div>
        <p className="font-display font-bold text-lg">
          {error ? "Échec de la connexion" : "Connexion en cours…"}
        </p>
        {error && (
          <button onClick={() => window.location.replace("/")} className="mt-4 rounded-sm bg-primary text-primary-foreground px-4 py-2 text-sm font-semibold">
            Retour à l'accueil
          </button>
        )}
      </div>
    </div>
  );
}
